// Navigation

import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'
import Listrak from '../Listrak'
import { error, log } from '../Log'

export const goToCart = async () => {
  Listrak.listrakEmptyCart()
  const [{ default: Router }] = await allPromisesWithRetries(() => [import('next/router')])
  log('goToHome')
  await Router.push('/cart.php')
}

export const goToHome = async () => {
  const [{ default: Router }] = await allPromisesWithRetries(() => [import('next/router')])
  log('goToHome')
  await Router.push('/')
}

export const goToConfirmation = async (orderId: number | string, zip = '') => {
  const [{ default: Router }] = await allPromisesWithRetries(() => [import('next/router')])
  log('goToConfirmation: Going to checkout with orderId ', orderId)
  const path = `/checkout/order-confirmation/${orderId}${zip ? `?zip=${zip}` : ''}`
  log(`path: ${path}`)
  await Router.push(path)
}

export const setPageTitle = (title: string) => {
  try {
    document.title = `One Kings Lane ${title}`
  } catch (err) {
    error('Failed to set document title', err)
  }
}

type SetCustomerLocalStorage = (i: { customerId: string | number, customerEmail: string }) => void
export const setCustomerLocalStorage: SetCustomerLocalStorage = ({ customerId, customerEmail }) => localStorage.setItem('customer', JSON.stringify({ customerId, customerEmail }))

export const getPageUrl = () => window.location.href
/**
 * Update the path to the specified string. Either absolute or relative to
 * the root, without triggering a page fresh.
 */
export const updateCurrentPathTo = (path) => window.history.pushState({}, '', path)

export const reloadPage = async () => {
  const [{ default: Router }] = await allPromisesWithRetries(() => [import('next/router')])
  log('reloadPage')
  Router.reload()
}
